import { Button } from '@/shared/ui';
import EnterArrow from '@/assets/icons/enter-icon.svg';
import { useEffect } from 'react';
import useDeviceType from '@/shared/hooks/useDeviceType';

interface IProps {
    subTitle: string;
    icon: string;
    children: React.ReactNode;
    alignItems?: string; // New prop for alignment
}

const RegisterV2Layout = ({ subTitle, icon, children}: IProps) => {
    return (
        <div data-testid="register-v2-layout-container" className={`relative z-10 flex w-max md-max:px-[20px] mt-[75px] sm:mt-[150px]`}>
            <div className="flex w-full max-w-[685px] flex-col">
                <h3 data-testid="register-v2-layout-subtitle" className="flex items-center gap-2.5 font-agrandir text-19 sm:text-25 lg:gap-3 mb-4 sm:mb-6">
                    <img src={icon} alt="icon" />
                    {subTitle}
                </h3>
                {children}
            </div>
        </div>
    );
};

interface ILayoutActionsProps {
    disabled?: boolean;
    btnText?: string;
    btnTestId?: string;
    onClick?: () => void;
}

export const LayoutActions = ({ disabled, btnTestId, btnText = 'Continue', onClick }: ILayoutActionsProps) => {
    const { deviceType } = useDeviceType();
    const isDesktop = deviceType === 'desktop';

    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Enter' && isDesktop) {
                onClick?.();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isDesktop, onClick]);

    return (
        <div className="flex flex-wrap justify-center items-center gap-4">
            <Button
                testId={btnTestId || 'button-continue'}
                className="ms-max:w-full"
                disabled={disabled}
                loading={false}
                variant="contained"
                color="primary"
                sx={{
                    boxShadow: '0px 4px 7.1px 0px #0000000F',
                    minWidth: '222px',
                    maxWidth: '100%'
                }}
                onClick={onClick}
                fontClassName='font-bold'
            >
                {btnText}
            </Button>
            {isDesktop && (
                <div className="flex items-center gap-1.5 font-dmSans text-17">
                    <span>
                        press
                        <strong> Enter</strong>
                    </span>
                    <img src={EnterArrow} alt="" />
                </div>
            )}
        </div>
    );
};

export default RegisterV2Layout;
